import React, {useContext, useMemo, Fragment} from 'react';
import {Link, useParams} from 'react-router-dom';
import {DataTablePage} from '@common/datatable/page/data-table-page';
import {Trans} from '@common/i18n/trans';
import {DataTableEmptyStateMessage} from '@common/datatable/page/data-table-emty-state-message';
import articlesSvg from './articles.svg';
import {DataTableAddItemButton} from '@common/datatable/data-table-add-item-button';
import {PostDatatableFilters} from './post-datatable-filters';
import {DeleteSelectedItemsAction} from '@common/datatable/page/delete-selected-items-action';
import {PostDatatableColumns} from '@app/blog/post/post-datatable-columns';
import {SiteConfigContext} from '@common/core/settings/site-config-context';
import {Footer} from '@common/ui/footer/footer';
import {DashboardNavbar} from '@app/dashboard/dashboard-navbar';
import {StaticPageTitle} from '@common/seo/static-page-title';
import {BlogSidebar} from '@app/blog/blog-sidebar';

export function PostDatablePage() {
  const config = useContext(SiteConfigContext);
  const { site_id } = useParams();
  const filters = useMemo(() => {
    return PostDatatableFilters(config);
  }, [config]);

  return (
    <Fragment>      
      <StaticPageTitle>
        <Trans message="Dashboard" />
      </StaticPageTitle>      
      <DashboardNavbar />
      <div className="flex h-full">
        {/* Sidebar Menu */}
        <BlogSidebar />
        {/* Main Content */}
        <div className="flex-1 p-6">
          <DataTablePage
            endpoint={`blogs/${site_id}`}
            title={<Trans message="Posts" />}
            
            columns={PostDatatableColumns}
            queryParams={{ with: 'category' }}
            actions={<Actions />}
            selectedActions={<DeleteSelectedItemsAction />}
            emptyStateMessage={
              <DataTableEmptyStateMessage
                image={articlesSvg}
                title={<Trans message="No posts have been created yet" />}
                filteringTitle={<Trans message="No matching posts" />}
              />
            }
          />
        </div>
      </div>
      <Footer className="mt-40 px-40" />
    </Fragment>
    
  );
}

function Actions() {
  return (
    <DataTableAddItemButton elementType={Link} to="new">
      <Trans message="New post" />
    </DataTableAddItemButton>
  );
}
